import React, {FC, useEffect, useRef, useState} from 'react';
import {Link} from 'react-router-dom';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Slider from 'react-slick';
import {Button} from '../components/Button';
import {H2} from '../components/H2';
import {Section} from '../components/Section';
import {ReactComponent as RadioLogo} from '../assets/svg/radio-logo.svg';
import {RadioCard} from '../components/RadioCard';
import {Icon} from '../components/Icon';
import {getContents} from '../apis/contents';
import {Content} from '../types/types';
import {throttle} from 'lodash';
import moment from "moment";
import {nToast} from "../plugins/reactToast";
import { ContentInfoEventProperties, ContentTabEventProperties } from '../types/amplitudeEventProperties';
import { Bridge } from '../plugins/bridge';
import { BRAZE_EVENT } from '../constants/braze';
import InfiniteScroll from "react-infinite-scroll-component";

export const JournalPage = () => {
  const [slidesToShow, setSlidesToShow] = useState(3);
  const [radioCardSize, setRadioCardSize] = useState(278);
  const sldieToShowRef = useRef(slidesToShow);
  const radioCardSizeRef = useRef(radioCardSize);
  const [headerHover, setHeaderHover] = useState(false);
  const slider = useRef<Slider | null>(null);
  const [journals, setJournals] = useState<Content[]>([]);
  const [page, setPage] = useState<number>(0);
  const [totalPages, setTotalPages] = useState<number>(0);

  const handleResize = throttle(() => {
    const nextSlidesToShow = Math.floor((window.innerWidth - 50) / 278);
    if (sldieToShowRef.current !== nextSlidesToShow) {
      setSlidesToShow(nextSlidesToShow || 1);
    }
    if (window.innerWidth <= 278) {
      setRadioCardSize(window.innerWidth);
    } else if (sldieToShowRef.current !== 278) {
      setRadioCardSize(278);
    }
  }, 100);

  useEffect(() => {
    const contentEventProperties : ContentTabEventProperties = {
      content_tab : "기사"
    }
    Bridge.sendAmplitude('content_list_page_viewed', contentEventProperties);  
  }, []);

  useEffect(() => {
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => {
      // cleanup
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    sldieToShowRef.current = slidesToShow;
  }, [slidesToShow]);

  useEffect(() => {
    radioCardSizeRef.current = radioCardSize;
  }, [radioCardSize]);

  useEffect(() => {
      getList();
  }, [page]);

  const getList = () => {
    getContents('CARHARTT_JOURNAL', page, 9).then(r => {
            setJournals([...journals!, ...r.data.payload.content]);
            setTotalPages(r.data.payload.totalPages);
        },
    ).catch(e => console.log(e));
  };

  if (journals.length === 0) return null;
  return (
      <>
        <Section
            onMouseOver={() => setHeaderHover(true)}
            onMouseLeave={() => setHeaderHover(false)}
            className="-mx-4 cursor-pointer ease-in-out duration-500 journal_t top_banner_b">
            <div className="journal_t md:block hidden" style={{background: 'url(https://s3.ap-northeast-2.amazonaws.com/carhartt-wip.entropyparadox.link/static/media/journal/220921_journalimage.jpeg) center no-repeat', backgroundSize:'cover',width:'100%',height:'calc(100vh - 400px)'}}>
                {/*<div className="journal_t md:block hidden" style={{background: 'url(https://s3.ap-northeast-2.amazonaws.com/carhartt-wip.entropyparadox.link/static/media/journal/220803_journalimage2.jpeg) center no-repeat', backgroundSize:'cover',width:'100%',height:'calc(100vh - 55px)'}}>*/}
                <div className="journal_t_in w-full h-full bg-white" />
                <Link
                    to={`/journal/${journals[0].id}`}
                    className="absolute z-10 left-0 right-0 2xl:top-52 top-32 space-y-2 md:space-y-10 max-w-md m-auto text-center">
                    <H2
                        className={`font-normal text-20 duration-300 ${
                            headerHover ? 'text-black' : 'text-white'
                        } `}>
                        가을/겨울 2023 - 칼하트윕의 최신 소식
                    </H2>
                    <Button
                        text="기사 보러가기"
                        className={`h-10 md:h-12 w-56 m-auto px-10 rounded-md font-mideum duration-300 ${
                            headerHover ? 'bg_3e52bb text-white' : 'bg_3e52bb text-white'
                        } `}
                        onClick = {()=>{journal_clicked(journals[0].id, journals[0].title)}}
                    />
                </Link>
            </div>
          {/*  mobile*/}
            <div className="journal_t md:hidden block" style={{background: 'url(https://s3.ap-northeast-2.amazonaws.com/carhartt-wip.entropyparadox.link/static/media/journal/220921_journalimage.jpeg) center no-repeat', backgroundSize:'cover',width:'100%',height:'calc(40vh)'}}>
                <div className="journal_t_in w-full h-full bg-white" />
                <Link
                    to={`/journal/${journals[0].id}`}
                    className="absolute z-10 left-0 right-0 top-40 space-y-2 md:space-y-10 max-w-md m-auto text-center">
                    <H2
                        className={`font-normal text-20 duration-300 ${
                            headerHover ? 'text-black' : 'text-white'
                        } `}>
                        가을/겨울 2023 - 칼하트윕의 최신 소식
                    </H2>
                    <Button
                        text="기사 보러가기"
                        className={`h-10 md:h-12 w-56 m-auto px-10 rounded-md font-mideum duration-300 ${
                            headerHover ? 'bg_3e52bb text-white' : 'bg_3e52bb text-white'
                        } `}
                        onClick = {()=>{journal_clicked(journals[0].id, journals[0].title)}}
                    />
                </Link>
            </div>
        </Section>
        <InfiniteScroll
            next={() => setPage(page + 1)}
            dataLength={journals.length}
            hasMore={(totalPages > 0 && page !== totalPages - 1)}
            loader={
                <div className="flex justify-center">
                    <Icon.MoreHorizontal/>
                </div>
            }>
            <Section className=" max-w-screen-2xl mx-auto flex md:flex-row flex-col md:space-x-16 md:pt-20">
              {journals.slice(0, 3).map((item, index) => {
                const idx = (index + 1) % 3;
                return (
                    <JournalCard
                        key={index}
                        id={item.id}
                        thumbnail={item.rawImageUrl!}
                        title={item.title}
                        tag={[moment(item.createdAt).format('YYYY.MM.DD')]}
                        className={`${
                            idx === 0 ? 'mt-20' : idx === 1 ? 'mt-10' : ''
                        } mb-16 mx-7`}
                    />
                );
              })}
            </Section>

            {/* <Section className="bg-brand-2 -mx-4 py-8 space-y-8">
              <div className="flex justify-center">
                <RadioLogo />
              </div>

              <div className="relative">
                <div
                    onClick={() => slider.current?.slickPrev()}
                    className="z-10 absolute left-0 h-full bg-gray-50 bg-opacity-70 w-16 md:w-32 grid place-items-center select-none cursor-pointer">
                  <Icon.ArrowLeft />
                </div>
                <div
                    onClick={() => {
                      slider.current?.slickNext();
                    }}
                    className="z-10 absolute right-0 h-full bg-gray-50 bg-opacity-70 w-16 md:w-32 grid place-items-center select-none cursor-pointer">
                  <Icon.ArrowRight />
                </div>
                <Slider
                    ref={slider}
                    centerMode
                    centerPadding={'0px'}
                    arrows={false}
                    slidesToShow={slidesToShow}
                    slidesToScroll={1}>
                  {new Array(20).fill(0).map((_, index) => (
                      <RadioCard
                          size={radioCardSize}
                          key={index}
                          artist="Artist"
                          show="Show"
                          url={'https://www.google.com'}
                      />
                  ))}
                </Slider>
              </div>
            </Section> */}

            <Section className="max-w-screen-2xl mx-auto grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 pt-20">
              {journals.slice(3, 1000).map((item, index) => {
                const idx = (index + 1) % 3;
                return (
                    <JournalCard
                        key={index}
                        id={item.id}
                        thumbnail={item.rawImageUrl!}
                        title={item.title}
                        tag={[moment(item.createdAt).format('YYYY.MM.DD')]}
                        className={`${
                            idx === 0 ? 'mt-20' : idx === 1 ? 'mt-10' : ''
                        } mb-16 mx-7`}
                    />
                );
              })}
            </Section>
        </InfiniteScroll>
          {/*{(totalPages > 0 && page !== totalPages - 1) && (
              <div className="grid place-content-center w-full pb-20">
                  <Button
                      text="이전 게시물 보기"
                      style={{backgroundColor: '#3E53BB'}}
                      className="text-white rounded-sm px-8"
                      onClick={() => setPage(page + 1)}
                  />
              </div>
          )}*/}
      </>
  );
};

interface JournalCardProps {
  thumbnail: string;
  title: string;
  tag: any[];
  className?: string;
  id: number;
}

export const JournalCard: FC<JournalCardProps> = ({
                                                    thumbnail,
                                                    title,
                                                    tag,
                                                    className,
                                                    id,
                                                  }) => {
  const [hover, setHover] = useState(false);
  return (
      <Link to={`/journal/${id}`} className={`${className} space-y-3`}
        onClick = {() => journal_clicked(id, title)}>
        <div
            onMouseOver={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
            className="relative">
          <div
              className={`${
                  hover
                      ? 'ease-in-out duration-500 opacity-100 cursor-pointer'
                      : 'ease-in duration-250 opacity-0 pointer-events-none'
              } bg-littleblack absolute top-0 h-full w-full`}
          />
          <img src={thumbnail} alt="" className="" />
        </div>

        <p className="text-brand-1 font-bold">{title}</p>

        {tag.map(item => (
            <span key={item} className="text-12 text-gray-400 uppercase mr-2">
          {item}
        </span>
        ))}
      </Link>
  );
};

function journal_clicked(journal_id : number, journal_name : string){
  const content = {
    content_tab : "기사",
    content_id : String(journal_id),
    content_name : journal_name
  }  

  Bridge.sendAmplitude('content_clicked', content);
}